var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 68,
    viewBox: "0 0 102 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M101 62.6822L98.619 58.0333C96.2381 53.3845 91.4762 44.0867 86.7143 37.2194C81.9524 30.3522 77.1905 25.9153 72.4286 34.2333C67.6667 42.5512 62.9048 63.624 58.1429 62.9858C53.381 62.3477 48.619 39.9986 43.8571 28.9776C39.0952 17.9566 34.3333 18.2636 29.5714 26.9776C24.8095 35.6916 20.0476 52.8125 15.2857 49.884C10.5238 46.9556 5.7619 23.9778 3.38095 12.4889L1 1",
    stroke: "#21ADFF",
    strokeWidth: 1.5098,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2 66.6405L4.28959 61.3822C6.57918 56.1239 11.1584 45.6073 15.7375 37.8397C20.3167 30.0721 24.8959 25.0536 29.4751 34.4621C34.0543 43.8705 38.6335 67.7058 43.2126 66.984C47.7918 66.2621 52.371 40.9832 56.9502 28.5173C61.5294 16.0515 66.1085 16.3988 70.6877 26.2552C75.2669 36.1115 79.8461 55.4769 84.4253 52.1646C87.0905 50.5604 93.7367 45.9256 99 40.2202",
    stroke: "#496DFF",
    strokeWidth: 1.5098,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.71a0856484e4d74dd22df3cb182eaf52.svg";
export { ForwardRef as ReactComponent };